import { WidgetsNoAccessMain } from '@/widgets/no-access';

export const PagesNoAccessMain = () => <WidgetsNoAccessMain />;
